import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonSvg } from '../Svg';
import { chameleonProgressStep } from './ProgressStep/ProgressStep.definition';
import { chameleonProgressStepPanel } from './ProgressStepPanel/ProgressStepPanel.definition';
import { chameleonProgressStepper } from './ProgressStepper.definition';
import { chameleonTooltipV2 } from '../TooltipV2';
import '@getgo/chameleon-typography/register/default';
provideChameleonDesignSystem().register(chameleonProgressStepper(), chameleonProgressStep(), chameleonProgressStepPanel(), chameleonSvg(), chameleonTooltipV2());
